<button
  class="unavailable-modal__close"
  type="button"
  (click)="close()"
>
  <icon
    height="16px"
    width="16px"
    [src]="'./assets/img/icons/close.svg'"
  />
</button>

<div class="unavailable-modal__icon-wrapper">
  <icon
    height="32px"
    width="32px"
    [src]="'./assets/img/icons/info.svg'"
  />
</div>

<div class="unavailable-modal__content margin-card">
  <div class="h2 unavailable-modal__title">
    {{ socialMethod }} {{ (isLoginContext ? 'unavailable-modal.method.title.sign-in' : 'unavailable-modal.method.title.sign-up') | translate }}
  </div>

  <p class="unavailable-modal__description">
    {{ descriptionKey | translate: descriptionParams }}
  </p>
</div>

@if (!isLoginContext) {
  <div class="unavailable-modal__alternatives">
    @for (method of socialMethods; track method.id) {
      <button
        class="button-border unavailable-modal__alternatives-button"
        type="button"
        (click)="onSocialMethodClick(method)"
      >
        <icon
          height="15px"
          width="15px"
          [src]="'./assets/img/icons/social/' + method.icon + '.svg'"
        />
        <span class="button-text">
          {{ method.name }}
        </span>
      </button>
    }

    @if (emailAvailable) {
      <button
        class="button-border unavailable-modal__alternatives-button email-icon"
        type="button"
        (click)="onEmailClick()"
        (mouseenter)="isHovered.set(true)"
        (mouseleave)="isHovered.set(false)"
      >
        <icon
          height="15px"
          width="18px"
          [src]="getIconSrc()"
        />
        <span class="button-text">
          {{ 'unavailable-modal.method.email-button' | translate }}
        </span>
      </button>
    }
  </div>
}

@if (isLoginContext) {
  <div class="unavailable-modal__actions">
    <button
      class="button-border"
      type="button"
      (click)="onResetPassword()"
    >
      {{ 'unavailable-modal.method.reset-password-button' | translate }}
    </button>

    <button
      class="link"
      type="button"
      (click)="onContactSupport()"
    >
      {{ 'unavailable-modal.method.support-link' | translate }}
    </button>
  </div>
}
